import React from 'react';
import { useSafariPadding } from '@/hooks/useSafaryPadding';
import { useAnalyticsScreenView } from '@/firebase/hooks/useAnalyticsScreen';

interface AppScreenProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  minTopPadding?: number;
  minBottomPadding?: number;
}

const AppScreen: React.FC<AppScreenProps> = ({
  children,
  className = '',
  style,
  minTopPadding = 0,
  minBottomPadding = 0,
}) => {

  const paddingBottom = useSafariPadding();
  useAnalyticsScreenView()

  return (
  <div
    className={`h-full flex flex-col relative overflow-x-hidden overflow-y-hidden bg-no-repeat bg-center bg-cover relative ${className}`}
    style={{
      paddingTop: `max(calc(env(safe-area-inset-top, 0px)), ${minTopPadding}px)`,
      paddingBottom: `max(calc(env(safe-area-inset-bottom, 0px)), ${minBottomPadding}px, ${paddingBottom}px)`,
      ...style,
    }}
  >
    {children}
  </div>
)};

export default AppScreen; 
